import { skipToken, useMutation, useQuery } from '@tanstack/react-query';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import { ClientStatus, IClientDTO } from '../../common/interfaces/client.interface';
import { addClient, getClient, getClients, updateClient } from './client.api';

export const useClientsQuery = (
  companyId: number,
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
  status?: ClientStatus,
) => {
  return useQuery({
    queryKey: ['clients', companyId, limit, page, search, orderBy, orderDirection, status],
    queryFn: () => getClients(companyId, limit, page, search, orderBy, orderDirection, status),
  });
};

export const useClientQuery = (id?: string) => {
  return useQuery({
    queryKey: ['client', id],
    queryFn: id ? () => getClient(id) : skipToken,
  });
};

export const useAddClientMutation = () => {
  return useMutation({
    mutationKey: ['client', 'add'],
    mutationFn: (payload: IClientDTO) => addClient(payload),
  });
};

export const useUpdateClientMutation = () => {
  return useMutation({
    mutationKey: ['client', 'update'],
    mutationFn: (payload: IClientDTO) => updateClient(payload),
  });
};
